import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "features/auth/authApi";
import { notificationsSlice } from "features/notifications/notificationsSlice";
import { appSlice } from "features/app/appSlice";
import { registerSlice } from "features/register/registerSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { listApi } from "features/list/listApi";
import { financeApi } from "features/finance/financeApi";
import { feesApi } from "features/fees/feesApi";
import { transferPageSlice } from "features/transfer-page/transferPageSlice";
import { exchangeApi } from "features/exchange/exchangeApi";
import { countriesApi } from "features/counteris/countriesApi";
import { settingsApi } from "features/settings/settingsApi";
import { siteApi } from "features/site/siteApi";
import { tradeApi } from "features/trade/tradeApi";
import { tronStakingApi } from "../features/tron-staking/tronStakingApi";
export const store = configureStore({
  reducer: {
    notifications: notificationsSlice.reducer,
    app: appSlice.reducer,
    register: registerSlice.reducer,
    transferPage: transferPageSlice.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [listApi.reducerPath]: listApi.reducer,
    [financeApi.reducerPath]: financeApi.reducer,
    [feesApi.reducerPath]: feesApi.reducer,
    [exchangeApi.reducerPath]: exchangeApi.reducer,
    [countriesApi.reducerPath]: countriesApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [siteApi.reducerPath]: siteApi.reducer,
    [tradeApi.reducerPath]: tradeApi.reducer,
    [tronStakingApi.reducerPath]: tronStakingApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(listApi.middleware)
      .concat(financeApi.middleware)
      .concat(feesApi.middleware)
      .concat(exchangeApi.middleware)
      .concat(countriesApi.middleware)
      .concat(settingsApi.middleware)
      .concat(siteApi.middleware)
      .concat(tradeApi.middleware)
      .concat(tronStakingApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
